<div class="pt-md-4 pt-xxl-5 vh-100 login-bgc">
  <nav>
    <img src="/assets/Images/TM_Logo.png" alt="">
  </nav>
  <div class="d-flex flex-column-reverse flex-md-row justify-content-between pt-md-2 pt-xxl-5 pt-3">
    <div class="content-block d-flex flex-column justify-content-between">
      <h1 class="text-white display-5">Customer Relationship Management</h1>
      <p class="h6 text-white">CRM system for travel agencies involves creating an intuitive, user-friendly interface
        that caters to the needs of both
        the travel agents and their clients.</p>

    </div>
    <div class="form-block">
      <h1 class="display-5 mb-3 font-weight-normal text-white text-center">Email Verification Failed!</h1>

      <div class="head-container text-white mb-3">
        Your email verification attempt was unsuccessful. Until this issue is resolved
        This prevents you from accessing email-sending features tied to this account.
      </div>

      <div class="head-container text-white mb-3">
        Please reach out to you admin for help: contact&#64;tripmeld.com / +91 92811 17175
      </div>

      <div class="head-container text-white">
        If you like to login to your account, please click the  <a class="link-orange" (click)="gotoLogin()">here</a>
      </div>
    </div>
  </div>
</div>